<link href="https://maxcdn.bootstrapcdn.com/font-awesome/4.3.0/css/font-awesome.min.css" rel="stylesheet">

<section class="main-section deskContent">
  <nav aria-label="breadcrumb">
    <ol class="breadcrumb">
      <li class="breadcrumb-item" *ngIf="user.role === 'ROLE_ADMIN'"><a routerLink="/admin/adminDashboard/">Home</a></li>
      <li class="breadcrumb-item" *ngIf="user.role === 'ROLE_ADMIN'"><a routerLink="/admin/stockAdminList/">Inbound Orders</a></li>
      <li class="breadcrumb-item" *ngIf="user.role === 'ACCOUNT_OWNER' || user.role == 'DEMO_ACCOUNT'"><a routerLink="/admin/dashboard/">Home</a></li>
      <li class="breadcrumb-item" *ngIf="user.role === 'ACCOUNT_OWNER' || user.role == 'DEMO_ACCOUNT'"><a routerLink="/admin/stockEntryList/">Inbound Orders</a></li>
      <li class="breadcrumb-item active" aria-current="page">Track Inbound Order</li>
    </ol>
  </nav>
  <div class="inner-box" style="height:100%;max-height: 580px;margin-top: 40px;">
    <div class="d-flex">
      <div class="col-2 d-flex" id="div1" style="border-right:1px solid #ccc;overflow:auto;">
        <div class="timeline-centered timeline-sm" id="defaultBar">
          <ng-container>
            <article class="timeline-entry" *ngFor="let t of getTrackOrderData;let i = index;">
              <div class="timeline-entry-inner"  style="height:100px">
                <label id="bar" class="" style="margin-left: 16px;height : 125px;" *ngIf="i < getTrackOrderData.length-1"></label>
                <time datetime="2014-01-10T03:45" class="timeline-time"><span></span></time>
                <div class="timeline-icon bg-green" style="background-color:#ee7125;"></div>
                <div class="timeline-label"><h4 class="timeline-title">{{(t.subject == 'SUBMITTED' ? 'Order Placed' : t.subject)}}</h4>
                  <p>{{t.status}}</p>
                  <p>{{t.activityDate | date : 'dd-MM-yyyy'}}</p>
                </div>
              </div>
            </article>
          </ng-container>
        </div>
      </div>
      <div class="col-10 d-flex" id="div2" style="display:block!important;">
        <div class="row mb-4">
          <div class="col-6 mt-2">
            <label class="mr-3" style="font-size:24px;font-weight: 600;margin-top: -6px;">Order#
              {{getData?.stockEntryNumber}}</label> <span class="v1"></span>
            <label class="ml-3 stus">{{getData?.status | replaceStatus}}</label>
            <div><label><b>Tracking # </b><a (click)="trackOrder()">{{getData?.trackingNumberList}}</a></label></div>
          </div>
          <div class="col-6 mt-2">
            <div style="text-align: right;" class="mr-4">
              <span><i class="fa fa-calendar mr-2" aria-hidden="true"></i><b>Order Date: </b>{{getData.createdDate | date: 'dd/MM/yyyy'}}</span>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="inner-box ml-4 mr-4" style="border:1px solid #ccc;width:500px;height: 250px;">
            <h2>Address Info</h2><br>
            <label><b> Contact Name :</b> {{getData?.contactName}}</label>
            <label><b> Address :</b> {{getData?.contactAddressText}}</label>
          </div>
          <div class="inner-box mr-4" style="border:1px solid #ccc;width:500px;height: 250px;">
            <h2>Shipped By
              {{(getData?.shippingOption == 'WF' ? 'Borzo' :(getData?.shippingOption == 'GT' ? 'Gati' :
                (getData?.shippingOption == 'SF' ? 'Shadow Fax' : (getData?.shippingOption == 'PR' ?
                  'Pickrr' : (getData?.shippingOption == 'SG' ? 'Shipigo' :
                    (getData?.shippingOption == 'COMPLETED' ? 'Completed' : (getData?.shippingOption == 'DRAFT' ? 'Draft'
                      :(getData?.shippingOption == 'TO_PICK' ? 'To Pick':(getData?.shippingOption == 'PRODUCT_ALLOTTED' ?
                        'Product Allotted' :(getData?.shippingOption == 'TOTE_ASSIGNED' ? 'Tote Assigned':(getData?.shippingOption
                        == 'TO_PACK' ? 'To Pack' :(getData?.shippingOption == 'PARTIALLY_DONE' ? 'Partially Done'
                          :(getData?.shippingOption | titlecase)))))))))))))}}</h2><br>
            <label>You can also contact the Seller or may call us at <br><b>
              <a href = "tel:+918904291440">+91 890 429 1440</a></b>about the tracking
              info</label>
          </div>
        </div>
        <div class="btn-section" style="bottom: 52px!important;">
          <div class="row">
            <div class="col-12 text-right">
              <button type="reset" class="btn btn-cancel" style="width: 200px;" (click)="CustomerSupportDisplay()"><i
                class="fa fa-comment mr-2" style="margin:0px!important;margin-right:8px!important;"></i> Customer
                Support
              </button>
              <button type="submit" class="btn btn-cancel ml-2"><i class="fa fa-pencil mr-1"
                                                                   style="margin:0px!important;margin-right:8px!important;"></i>
                Create
              </button>
              <!--<button type="submit" class="btn btn-cancel ml-2" (click)="cancelOrderDisplayDisplay()"><i
                class="fa fa-times mr-2" style="color:#ff0000;margin:0px;"></i> Cancel Order</button>-->
            </div>
          </div>
        </div>
        <!--<div style=" border-left: 1px solid #ccc;height: 600px;"></div><br>-->
      </div>
      <div class="col-2  d-none" id="div3" style="border-left:1px solid #ccc">
        <div class="row">
          <div class="col">
            <div>
              <div style="display: flex;"><h2 class="mb-2">Cancel Order <div class="ficon" (click)=" displayRoute()"><i
                class="fa fa-times"></i></div></h2></div>


              <ng-select id="accountOwner"
                         required
                         [items]=""
                         [searchWhileComposing]="true">

              </ng-select>
            </div>
          </div>
        </div>
        <div class="cs-order">
          <div class="row">
            <div class="text-center">

              <button type="submit" class="btn btn-orange" style="width:100%;">Submit</button>
            </div>
          </div>
        </div>
      </div>
      <div class="col-2 d-none" id="div4" style="border-left:1px solid #ccc">
        <div class="row mt-4">
          <div class="col ml-2">
            <div>
              <div style="display: flex;"><h2 class="mb-2">Customer Support<div class="ficon"  (click)=" displayRoute()"><i
                class="fa fa-times"></i></div>
              </h2></div>

              <input type="text" id="subject" [(ngModel)]="subject"
                     [ngModelOptions]="{standalone: true}" placeholder="Subject" class="form-control mb-3" required>
              <textarea type="text" id="description" placeholder="Description" [(ngModel)]="description"
                        [ngModelOptions]="{standalone: true}" class="form-control" required></textarea>
            </div>
          </div>
        </div>
        <div class="cs-order ml-2">
          <div class="row">
            <div class="col-12 text-center">
              <button type="submit" class="btn btn-orange" style="width:100%;" (click)="supportTicketCreate()">Submit
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>

</section>
<section class="main-section MobileContent">
  <nav aria-label="breadcrumb">
    <ol class="breadcrumb">
      <li class="breadcrumb-item" *ngIf="user.role === 'ROLE_ADMIN'"><a routerLink="/admin/adminDashboard/">Home</a></li>
      <li class="breadcrumb-item" *ngIf="user.role === 'ROLE_ADMIN'"><a routerLink="/admin/stockAdminList/">Inbound Orders</a></li>
      <li class="breadcrumb-item" *ngIf="user.role === 'ACCOUNT_OWNER' || user.role == 'DEMO_ACCOUNT'"><a routerLink="/admin/dashboard/">Home</a></li>
      <li class="breadcrumb-item" *ngIf="user.role === 'ACCOUNT_OWNER' || user.role == 'DEMO_ACCOUNT'"><a routerLink="/admin/stockEntryList/">Inbound Orders</a></li>
      <li class="breadcrumb-item active" aria-current="page">Track Inbound Order</li>
    </ol>
  </nav>
  <div class="inner-box">
    <div class="row">
      <div class="col-12 mt-2">
        <label class="mr-3" style="font-size:24px;font-weight: 600;margin-top: -6px;">Order#
          {{getData?.stockEntryNumber}}</label> <span class="v1"></span>
        <label class="ml-3 stus">{{getData?.status | replaceStatus}}</label>
        <div><label><b>Tracking # </b><a (click)="trackOrder()">{{getData?.trackingNumberList}}</a></label></div>
      </div>
      <!-- <div class="col-6 mt-2">
         <div style="text-align: right;" class="mr-4">
           <span><i class="fa fa-calendar mr-2" aria-hidden="true"></i><b>Order Date :</b> {{order?.orderedDate}}</span>
         </div>
       </div>-->
    </div>
    <div class="col-12 text-right mb-4" *ngIf="!customerSupport">
      <button type="reset" class="btn btn-cancel" style="width: 50px;" (click)="CSDisplay()"><i
        class="fa fa-comment mr-2" style="font-size:18px;margin: 4px!important;"></i>
      </button>
    </div>
    <div id="csorder" style="display:none;">
      <div class="row">
        <div class="col">
          <div>
            <div style="display: flex;"><h2 class="mb-2">Customer Support<span class="ficon" style="position: absolute;top:-17px;right: 0;left: unset;" (click)="CSDisplay()"><i
              class="fa fa-times"></i></span>
            </h2></div>

            <input type="text" id="subject" [(ngModel)]="subject"
                   [ngModelOptions]="{standalone: true}"  placeholder="Subject" class="form-control mb-3" required>
            <textarea type="text" id="description" placeholder="Description"[(ngModel)]="description"
                      [ngModelOptions]="{standalone: true}"  class="form-control" required></textarea>
          </div>
        </div>
      </div>
      <div class="" >
        <div class="row">
          <div class="col-12 text-right mt-3">
            <button type="submit" class="btn btn-orange" style="width:210px;" (click)="supportTicketCreate()">Submit</button>
          </div>
        </div>
      </div>
    </div>
    <div class="timeline-centered timeline-sm" style="margin-left: 160px!important;" id="defaultBar">
      <ng-container>
        <article class="timeline-entry" *ngFor="let t of getTrackOrderData;let i = index;">
          <div class="timeline-entry-inner"  style="height:100px">
            <label id="bar" class="" style="margin-left: 16px;height : 125px;" *ngIf="i < getTrackOrderData.length-1"></label>
            <time datetime="2014-01-10T03:45" class="timeline-time"><span></span></time>
            <div class="timeline-icon bg-green" style="background-color:#ee7125;"></div>
            <div class="timeline-label"><h4 class="timeline-title">{{(t.subject == 'SUBMITTED' ? 'Order Placed' : t.subject)}}</h4>
              <p>{{t.status}}</p>
              <p>{{t.activityDate | date : 'dd-MM-yyyy'}}</p>
            </div>
          </div>
        </article>
      </ng-container>
    </div>
    <div class="col-md-12 text-center">
      <div class="col-md-6">
        <button type="submit" class="btn btn-cancel mb-3" style="width: 100%!important;"><i class="fa fa-pencil mr-1"
                                                                                            style="margin:0px!important;margin-right:8px!important;"></i>
          Shop Again
        </button>
      </div>
      <!-- <div class="col-md-6">
         <button type="submit" class="btn btn-cancel" style="width: 100%!important;" (click)="ReturnOrder()"><i
           class="fa fa-times mr-2" style="color:#ff0000;margin:0px;"></i> Return Order</button>
       </div>-->
    </div>
    <!-- <div id="re-order" style="display: none;" class="mt-3">
       <div class="row">
         <div class="col">
           <div>
             <div style="display:flex;"><h2 class="mb-3">Return Order <div class="ficon" style="position: absolute;top: -17px;right: 0;left:unset;" (click)="ReturnOrder()"><i
               class="fa fa-times"></i></div></h2></div>
             <ng-select id="accountOwner"
                        required
                        [items]=""
                        [searchWhileComposing]="true">

             </ng-select>
           </div>
         </div>
       </div>
       <div class="mt-4" style="left: 35px!important;">
         <div class="row">
           <div class="col text-right">
             <button type="submit" class="btn btn-orange" style="width:210px;">Return Order</button>
           </div>
         </div>
       </div>
     </div>-->
  </div>
</section>

